import styled from "@emotion/styled";

const TextField:any = styled.input`
    color: ${(props:any) => (props.error ? '#ED3257 !important' : 'inherit !important')};
    border-color: ${(props:any) => (props.error ? '#ED3257 !important' : 'inherit !important')};
`

export default TextField